var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1050_17011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16641 1.16678H12.5279V12.5284H1.16641V1.16678Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1050_17011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84737 2.04178C4.19729 2.04178 2.04129 4.1972 2.04129 6.84728C2.04129 9.49736 4.19729 11.6534 6.84737 11.6534C9.49687 11.6534 11.6529 9.49736 11.6529 6.84728C11.6529 4.1972 9.49687 2.04178 6.84737 2.04178ZM6.84737 12.5284C3.71487 12.5284 1.16629 9.97978 1.16629 6.84728C1.16629 3.71478 3.71487 1.16678 6.84737 1.16678C9.97987 1.16678 12.5279 3.71478 12.5279 6.84728C12.5279 9.97978 9.97987 12.5284 6.84737 12.5284Z",
    fill: "#E6F7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1050_17011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 3,
    height: 4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0564 10.3292H12.9871V13.2544H10.0564V10.3292Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1050_17011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5497 13.2544C12.4383 13.2544 12.3263 13.2119 12.2405 13.1267L10.1849 11.0769C10.014 10.9059 10.0134 10.6289 10.1843 10.4579C10.3546 10.2859 10.6317 10.287 10.8032 10.4568L12.8589 12.5072C13.0298 12.6781 13.0304 12.9546 12.8595 13.1255C12.7743 13.2119 12.6617 13.2544 12.5497 13.2544Z",
    fill: "#E6F7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.4c44ba5ad4047821cbc682fcb00ca531.svg";
export { ForwardRef as ReactComponent };